import { useEffect } from "react"

/**
 * Manages animation state for a module based on its visibility.
 *
 * @param showModule Boolean indicating if the module is shown.
 * @param setIsAnimating Setter function to update animation state.
 */

export const useAnimatedModule = (
    showModule: boolean,
    setIsAnimating: (value: boolean) => void
) => {
    useEffect(() => {
        if (showModule) {
            setIsAnimating(false)
            setTimeout(() => setIsAnimating(true), 10)
        } else {
            setIsAnimating(false)
        }
    }, [showModule, setIsAnimating])
}
